import React from "react";
import { Link, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

const EmpNavbar = () => {
    const location = useLocation();

    return (
        <>
            <div className="top_navv">
                <div className="container-fluid ">
                    <div className="sunder_con_pad">
                        <nav className="navbar navbar-expand-lg  ">
                            <div className="container-fluid">
                                <a className="navbar-brand parikshapecharcha_logo" href="#">
                                    <img
                                        src="/assets/vimages/parikshapecharcha_logo.svg"
                                        alt=""
                                    />
                                </a>
                                <button
                                    className="navbar-toggler vtoggler_btn"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarToggler02"
                                    aria-controls="navbarToggler02"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div
                                    className="collapse navbar-collapse"
                                    id="navbarToggler02"
                                >
                                    <button className="CloseMenu" 
                                        type="button" 
                                        data-bs-toggle="collapse" 
                                        data-bs-target="#navbarToggler02" 
                                        aria-controls="navbarToggler02" 
                                        aria-expanded="false" 
                                        aria-label="Toggle navigation">CloseMenu</button>

                                    <ul className="navbar-nav vcust_nav mx-auto">
                                        <li className="nav-item">
                                            <Link
                                                className={`nav-link ${location.pathname === "/" ? "active" : ""
                                                    }`}
                                                aria-current="page"
                                                to="/parikshapecharcha2025"
                                            >
                                                Home
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link
                                                className={`nav-link ${location.pathname === "/allepisode" ? "active" : ""
                                                    }`}
                                                to="/parikshapecharcha2025/allepisode"
                                            >
                                                All Episodes
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link
                                                className={`nav-link ${location.pathname === "/shortreels" ? "active" : ""
                                                    }`}
                                                to="/shortreels"
                                            >
                                                Short Reels
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="me-auto mob_display" style={{visibility: 'hidden'}}>
                                    <div className="mygov_icon ">
                                        <img src="/assets/vimages/mygov_icon.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmpNavbar;
